export const defaultLocale = process.env['DEFAULT_LOCALE'] || 'en';
export const locales = (process.env['LOCALES'] || 'en,nl_NL,nl_BE').split(',');
